import { render } from "./TipTap.vue?vue&type=template&id=656a4264&ts=true"
import script from "./TipTap.vue?vue&type=script&lang=ts"
export * from "./TipTap.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__